import { render } from "./data-correction.vue?vue&type=template&id=d8419ab8&scoped=true"
import script from "./data-correction.vue?vue&type=script&lang=js"
export * from "./data-correction.vue?vue&type=script&lang=js"

import "./data-correction.vue?vue&type=style&index=0&id=d8419ab8&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8419ab8"]])

export default __exports__